import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
import { calculateRem } from '@vds-core/utilities';
import { Fonts } from '@vds-core/typography';
import AccordionAnimation from '../util/AccordionAnimation';
import { ColorTokens } from '@vds-tokens/color';
import { TypographyTokens } from '@vds-tokens/typography';
import { LayoutTokens } from '@vds-tokens/layout';
var PADDING_DEFAULT_MOBILE = LayoutTokens.space['6X'].value; // 24px

var PADDING_DEFAULT_NON_MOBILE = LayoutTokens.space['8X'].value; // 32px

var SlideOutContent = /*#__PURE__*/keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(0px);\n  }\n\n  to {\n    transform: translateY(-16px);\n  }\n"])));
var SlideInContent = /*#__PURE__*/keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from {\n    transform: translateY(-20px);\n  }\n\n  to {\n    transform: translateY(0px);\n  }\n"])));

var _calcPaddingBottom = function _calcPaddingBottom(viewport) {
  var isMobile = viewport === 'mobile';
  return isMobile ? PADDING_DEFAULT_MOBILE : PADDING_DEFAULT_NON_MOBILE;
};

var propTypes = {
  /**
   * @ignore
   */
  opened: PropTypes.bool,

  /**
   * @ignore
   */
  children: PropTypes.node.isRequired,

  /**
   * @ignore
   */
  groupId: PropTypes.string,

  /**
   * @ignore
   */
  surface: PropTypes.oneOf(['light', 'dark']),

  /**
   * @ignore
   */
  viewport: PropTypes.oneOf(['mobile', 'desktop', 'tablet']),

  /**
   * @ignore
   */
  paddingTop: PropTypes.number,

  /**
   * @ignore
   * Typography styles for children passed in the component
   * Defaults to false for 3.0
   */
  customChildrenTypography: PropTypes.bool,

  /**
   * @ignore
   * Function to render padding bottom when accordion is opened
   */
  calcPaddingBottom: PropTypes.func
};
var defaultProps = {
  opened: false,
  surface: 'light',
  groupId: null,
  viewport: 'desktop',
  //1.0,
  paddingTop: 6,
  calcPaddingBottom: _calcPaddingBottom
};

var _getBodySize = function _getBodySize(viewport, customChildrenTypography) {
  var isMobile = viewport === 'mobile';

  if (customChildrenTypography) {
    return TypographyTokens.fontsize.body[16].value;
  }

  return isMobile ? TypographyTokens.fontsize.body[12].value : TypographyTokens.fontsize.body[16].value;
};

var _getBodyLineHeight = function _getBodyLineHeight(viewport, customChildrenTypography) {
  var isMobile = viewport === 'mobile';

  if (customChildrenTypography) {
    return TypographyTokens.lineheight.body[20].value;
  }

  return isMobile ? TypographyTokens.lineheight.body[16].value : TypographyTokens.lineheight.body[20].value;
};

var _getFontFamily = function _getFontFamily(viewport, customChildrenTypography) {
  var isMobile = viewport === 'mobile';
  if (customChildrenTypography) return Fonts.VerizonNHGeDS;
  return isMobile ? Fonts.VerizonNHGeTX : Fonts.VerizonNHGeDS;
};

var ChildWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "ChildWrapper",
  componentId: "VDS__sc-19df7fd-0"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
  var opened = _ref.opened;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      transition: padding 350ms ease;\n      animation-name: ", ";\n      animation-duration: 350ms;\n      animation-delay: 100ms;\n      animation-timing-function: ease;\n    "])), opened ? SlideInContent : SlideOutContent);
});
var StyledAccordionDetail = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledAccordionDetail",
  componentId: "VDS__sc-19df7fd-1"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  background-color: ", ";\n  color: ", ";\n  ", "\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  transition: padding 350ms;\n  > * {\n    margin: 0;\n    &:not(:last-child) {\n      margin-bottom: ", ";\n    }\n  }\n  &:active,\n  &:hover {\n    outline: none;\n  }\n  ", ";\n"])), function (_ref2) {
  var opened = _ref2.opened,
      paddingTop = _ref2.paddingTop;
  return opened ? calculateRem(paddingTop) : 0;
}, function (_ref3) {
  var surface = _ref3.surface;
  return surface === 'dark' ? ColorTokens.background.primary.dark.value : ColorTokens.background.primary.light.value;
}, function (_ref4) {
  var surface = _ref4.surface;
  return surface === 'dark' ? ColorTokens.elements.primary.ondark.value : ColorTokens.elements.primary.onlight.value;
}, function (_ref5) {
  var viewport = _ref5.viewport,
      customChildrenTypography = _ref5.customChildrenTypography;
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", ";\n    ", ";\n    line-height: ", ";\n  "])), _getFontFamily(viewport, customChildrenTypography), calculateRem(_getBodySize(viewport, customChildrenTypography)), viewport !== 'mobile' && "\n      letter-spacing: ".concat(calculateRem(TypographyTokens.letterspacing.wide.value), ";"), calculateRem(_getBodyLineHeight(viewport, customChildrenTypography)));
}, calculateRem(8), function (_ref6) {
  var opened = _ref6.opened,
      paddingBottom = _ref6.paddingBottom;
  return opened && "\n    padding-bottom: ".concat(calculateRem(paddingBottom), ";\n    padding-top: 0;\n  ");
});

var AccordionDetail = /*#__PURE__*/function (_Component) {
  _inherits(AccordionDetail, _Component);

  var _super = _createSuper(AccordionDetail);

  function AccordionDetail() {
    var _this;

    _classCallCheck(this, AccordionDetail);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "isAndroidDevice", function () {
      return typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('android') > -1;
    }());

    return _this;
  }

  _createClass(AccordionDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var groupId = this.props.groupId;
      this.accordionDetailId = "accordionDetail_".concat(groupId);
      this.accordionAliasId = "accordionHeader_".concat(groupId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          opened = _this$props.opened,
          children = _this$props.children,
          groupId = _this$props.groupId,
          surface = _this$props.surface,
          viewport = _this$props.viewport,
          paddingTop = _this$props.paddingTop,
          customChildrenTypography = _this$props.customChildrenTypography,
          calcPaddingBottom = _this$props.calcPaddingBottom;
      var height = opened ? 'auto' : 0;
      return /*#__PURE__*/React.createElement(StyledAccordionDetail, {
        viewport: viewport,
        opened: opened,
        surface: surface,
        id: this.accordionDetailId,
        "aria-labelledby": this.accordionAliasId,
        onClick: this._onClick,
        paddingTop: paddingTop,
        tabIndex: opened ? undefined : -1,
        role: "region",
        "aria-hidden": !opened && this.isAndroidDevice,
        customChildrenTypography: customChildrenTypography,
        paddingBottom: calcPaddingBottom(viewport)
      }, /*#__PURE__*/React.createElement(AccordionAnimation, {
        height: height,
        opened: opened
      }, /*#__PURE__*/React.createElement(ChildWrapper, {
        opened: opened
      }, children)));
    }
  }]);

  return AccordionDetail;
}(Component);

_defineProperty(AccordionDetail, "componentType", 'AccordionDetail');

AccordionDetail.propTypes = propTypes;
AccordionDetail.defaultProps = defaultProps;
export default AccordionDetail;